import { render, staticRenderFns } from "./EncyclopediaPagination.vue?vue&type=template&id=1b0c9da8&"
import script from "./EncyclopediaPagination.vue?vue&type=script&lang=js&"
export * from "./EncyclopediaPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports